<template>
  <v-list two-line dense>
    <div v-if="inprocess.length > 0">
      <v-list-item
        v-for="item in inprocess"
        :key="item.id"
      >
        <v-list-item-avatar>
          <v-icon color="green">fas fa-running</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">
            {{ item.workorder.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-btn
              text
              outlined
              rounded
              small
              :to="{ name: 'WorkOrderSummaryView', params: { id: item.workorder.project_id, workid: item.workorder.id }}"
            >
              {{ item.workorder.forgeID }}
            </v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="detailed">
          <v-list-item-action-text>
            Finish Run
          </v-list-item-action-text>
          <ToolProcessCompleteButton :processid="item.id" />
        </v-list-item-action>
      </v-list-item>
    </div>
    <div v-else>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon color="primary">fas fa-sad-tear</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="primary--text">
          <v-list-item-title>
            No Work In Process
          </v-list-item-title>
          <v-list-item-subtitle>Must add a new workorder from the Pipeline</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="detailed">
          <v-list-item-action-text>Add New</v-list-item-action-text>
          <ToolProcessActiveAdd :toolid="toolid" />
        </v-list-item-action>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
import ToolProcessActiveAdd from "./ToolProcessActiveAdd";
import ToolProcessCompleteButton from "./ToolProcessCompleteButton";
export default {
  name: "ToolProcessActiveList",
  components: { ToolProcessCompleteButton, ToolProcessActiveAdd },
  props: {
    toolid: {
      type: [Number, String],
      required: true
    },
    detailed: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  computed: {
    inprocess() {
      return ToolProcess.query()
        .where("tool_id", parseInt(this.toolid))
        .where("in_process", true)
        .with("workorder")
        .get();
    }
  }
}
</script>
